export const hasValidServices = ({ context }) => {
    return Boolean(context.services && context.services.length > 0);
};
export const hasApproverSignature = ({ context }) => {
    return Boolean(context.approverSignature);
};
export const hasRejectionReason = ({ context }) => {
    return Boolean(context.rejectionReason);
};
export const hasRevocationReason = ({ context }) => {
    return Boolean(context.revocationReason);
};
//# sourceMappingURL=service-authorisation.js.map